<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn color="primary" x-small text @click="handleNavigateToHome">
            <v-icon left> fa fa-angle-left </v-icon>
            <span class="sr-only">Voltar</span>
          </v-btn>
          Planos
          <span class="meu-componente-especial">
            <e-help-tooltip :text="$constants.tooltips.planos.listarPlanos" />
          </span>
        </h1>
      </v-col>
    </v-row>

    <v-row v-if="canListarEAprovarPlanos">
      <v-col cols="12">
        <v-form>
          <v-card>
            <div class="text-start py-2 px-4 text-button">Pesquisa avançada</div>

            <v-divider class="theme--light" />

            <v-row class="px-4 mt-4">
              <v-col>
                <e-label>Professor</e-label>
                <v-text-field
                  v-model="professor"
                  label="NOME ou CPF Professor"
                  outlined
                  dense
                  clearable
                />
              </v-col>
            </v-row>

            <v-row class="d-flex justify-space-between mb-6 px-4">
              <v-col cols="12" sm="6" md="4">
                <e-label>Disciplina</e-label>
                <v-autocomplete
                  v-model="disciplina"
                  :items="disciplinas"
                  :return-object="false"
                  label="Escolha uma disciplina"
                  item-text="descricao"
                  item-value="descricao"
                  outlined
                  dense
                  clearable
                />
              </v-col>

              <v-col cols="12" sm="6" md="4">
                <e-label>Turma</e-label>
                <v-autocomplete
                  v-model="turma"
                  :items="turmas"
                  :return-object="true"
                  label="Escolha uma turma"
                  item-text="descricao"
                  outlined
                  dense
                  clearable
                />
              </v-col>

              <v-col cols="12" sm="6" md="4">
                <e-label>Etapa</e-label>
                <v-autocomplete
                  v-model="etapa_id"
                  :items="etapasList"
                  :return-object="false"
                  label="Escolha uma etapa"
                  item-text="descricao"
                  item-value="id"
                  outlined
                  dense
                  clearable
                />
              </v-col>

              <v-col cols="12" sm="12" md="12" class="mb-5">
                <v-btn color="primary" block @click="handleClearFilters"> Limpar filtros </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-form>
      </v-col>

      <v-col>
        <v-data-table
          :loading="carregando"
          :headers="tableHeaders"
          :items="planos"
          :items-per-page="15"
          hide-default-footer
          class="elevation-1"
        >
          <template v-slot:body="{ items }">
            <tbody
              v-if="items.length > 0"
              name="scroll-x-transition"
              is="transition-group"
              duration="150"
            >
              <tr v-for="plano of items" :key="plano.id" color="primary">
                <td>{{ plano.id || "- - -" }}</td>
                <td>{{ plano.gestao_de_aula.professor.nome }}</td>
                <td>{{ plano.gestao_de_aula.turma.descricao }}</td>
                <td>
                  <e-situacao-plano :plano="plano" @update="handleUpdateStatus" />
                </td>
                <td>{{ plano.etapa.descricao }}</td>
                <td>{{ plano.disciplina?.descricao }}</td>
                <td>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        class="ml-1"
                        color="orange"
                        v-bind="attrs"
                        v-on="on"
                        @click="handleNavigateToVisualize(plano.id)"
                      >
                        <v-icon small> mdi-note-text-outline </v-icon>
                        <span class="sr-only">Visualizar plano</span>
                      </v-btn>
                    </template>
                    <span>Visualizar</span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        class="ml-1"
                        color="orange"
                        v-bind="attrs"
                        v-on="on"
                        @click="handleVisualizePdf(plano.id)"
                      >
                        <v-icon small> mdi-note </v-icon>
                        <span class="sr-only">Visualizar Pdf</span>
                      </v-btn>
                    </template>
                    <span>Visualizar Pdf</span>
                  </v-tooltip>
                </td>
              </tr>
            </tbody>

            <tbody v-else>
              <tr>
                <td :colspan="tableHeaders.length" class="text-center pa-6">
                  <div>
                    <v-icon large color="grey lighten-1" class="mb-4">
                      mdi-folder-open-outline
                    </v-icon>
                    <div class="text-h6 grey--text text--darken-1 mb-2">
                      Nenhum plano encontrado
                    </div>
                    <div class="grey--text">Não há planos de aula cadastrados para exibir.</div>
                  </div>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>

        <e-paginate
          :current_page="paginate.current_page"
          :last_page="paginate.last_page"
          :page-number="pageNumber"
          :search="search"
          @changeActionResponse="handleLoadPlans"
        />
      </v-col>
    </v-row>

    <v-row v-else>
      <v-col cols="12" class="pa-4">
        <v-alert type="error" dense> Você não tem permissão para visualizar esse recurso. </v-alert>
      </v-col>
    </v-row>

    <ModalCarteira :dialog="dialog" :pdf="pdf" @update="handleUpdateStatus" />
  </main-template>
</template>

<script>
import { dataTableFilter } from "@/plugins/searchQuery";
import ModalCarteira from "@/components/Matriculas/EModalCarteira.vue";
import { mapGetters } from "vuex";

export default {
  name: "PlanosList",

  components: {
    ModalCarteira,
  },

  data() {
    return {
      carregando: false,
      dialog: false,
      pdf: null,
      disciplinas: [],
      meses: [],
      turmas: [],
      planos: [],
      professor: "",
      turma: "",
      disciplina: "",
      etapa_id: "",
      mes: "",
      search: "",
      pageNumber: 1,
      paginate: {
        current_page: 1,
        last_page: 1,
      },
      tableHeaders: [
        { text: "ID", value: "id" },
        { text: "Professor", value: "gestao_de_aula.professor.nome" },
        { text: "Turma", value: "gestao_de_aula.turma.descricao" },
        { text: "Status", value: "status" },
        { text: "Período", value: "etapa.descricao" },
        { text: "Disciplina", value: "gestao_de_aula.disciplina.descricao" },
        { text: "Ações", value: "actions", sortable: false },
      ],
      etapasList: [],
    };
  },

  computed: {
    ...mapGetters("Auth", ["user"]),

    canListarEAprovarPlanos() {
      try {
        return this.user.permissions.includes("planosBimestrais.aprovar");
      } catch (error) {
        this.$handleError(error);
        return false;
      }
    },
  },

  watch: {
    async professor(value) {
      const formattedValue = this.formatarCPf(value);
      this.professor = formattedValue;
      await this.handleLoadPlans();
    },
    async turma(value) {
      this.turma = value;
      await this.handleLoadPlans();
      await this.listarDisciplinas();
    },
    async disciplina(value) {
      this.disciplina = value;
      await this.handleLoadPlans();
    },
    async mes(value) {
      this.mes = value;
      await this.handleLoadPlans();
    },
    async etapa_id(value) {
      this.etapa_id = value;
      await this.handleLoadPlans();
    },
  },

  async mounted() {
    await this.loadData();
  },

  methods: {
    async loadData() {
      await this.handleLoadPlans(this.pageNumber);
      await this.listarTurmas();
    },

    async listarDisciplinas() {
      try {
        const serieId = this.turma?.series?.[0]?.id;
        if (!serieId) {
          this.disciplinas = [];
          return;
        }

        const disciplinasList =
          await this.$services.disciplinasService.listarDisciplinasComPlanoPorSerie(serieId);

        this.disciplinas = disciplinasList;
      } catch (error) {
        this.$handleError(error.error || error);
      }
    },

    async listarTurmas() {
      try {
        const { data } = await this.$services.planosService.turmas();
        const result = data.map((turma) => ({
          ...turma,
          descricao: `${turma.descricao} (${turma.franquia.descricao})`,
        }));
        this.turmas = result;
      } catch (error) {
        this.$handleError(error);
      }
    },

    async handleLoadPlans(numeroDaPagina = null) {
      this.paginate.current_page = numeroDaPagina || this.pageNumber;
      this.pageNumber = numeroDaPagina || this.pageNumber;

      try {
        this.dialog = false;
        this.carregando = true;

        const payload = await this.$services.planosService.index(
          this.pageNumber,
          this.professor,
          this.turma,
          this.disciplina,
          this.etapa_id,
          this.periodo
        );

        this.planos = payload.planos;
        this.paginate = payload.data;
        this.carregando = false;
      } catch (error) {
        this.$handleError(error);
      }
    },

    async handleUpdateStatus() {
      try {
        await this.handleLoadPlans();
      } catch (error) {
        this.$handleError(error);
      }
    },

    handleClearFilters() {
      this.professor = "";
      this.turma = "";
      this.disciplina = "";
      this.mes = "";
      this.etapa_id = "";
    },

    formatarCPf(value) {
      if (!value) return "";
      return value.replace(/-/g, "").replace(/\./g, "");
    },

    async handleVisualizePdf(planoId) {
      this.pdf = await this.$services.planosService.pdf(planoId);
      this.dialog = true;
    },

    handleNavigateToHome() {
      this.$router.push({ name: "home" });
    },

    handleNavigateToVisualize(planoId) {
      this.$router.push({
        name: "gestoesDeAulas.planosVisualizar",
        params: { id: planoId },
      });
    },
  },
};
</script>

<style scoped>
/* Adicione estilos scoped se necessário */
</style>
